import StatisticsLine from "./statistics-line.vue";

export default StatisticsLine;



// WEBPACK FOOTER //
// ./src/components/_charts/chart-types/statistics-line/index.js